/* VALNIA — carrega recomendações via Section Rendering API */
(function () {
  var el = document.querySelector('[data-recommendations-url]');
  if (!el) return;
  fetch(el.getAttribute('data-recommendations-url'))
    .then(function (r) { return r.text(); })
    .then(function (text) {
      var html = new DOMParser().parseFromString(text, 'text/html');
      var fresh = html.querySelector('[data-recommendations-inner]');
      if (fresh) el.innerHTML = fresh.innerHTML;
    })
    .catch(function () {});
})();
